import * as React from 'react';
import styles from './styles.module.styl';
var ALPHABET = [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
];
export var LettersBar = function (_a) {
    var letters = _a.letters;
    return (React.createElement("div", { className: styles.letterBar },
        React.createElement("ul", null, ALPHABET.map(function (letter) { return (React.createElement("li", { key: letter },
            React.createElement("a", { href: "#".concat(letter), className: !letters.includes(letter) ? 'disabled' : '' }, letter))); }))));
};
